import {
  REDIRECTING_TO_SRP_ERROR,
  REDIRECTING_TO_SRP_ERROR_HEADING,
  NO_BOOK_DATA_ERROR,
  ERROR_HEADING,
  IS_MWEB_LITE
} from '@stencil/flights-constants';
import {
  getRepriceAddonsAPI,
  getBRPDetails,
  postRepriceAddonsAPI,
  fareLockRequestAPI,
  baggageDataAndFareRulesAPI,
  getPriceAPI,
  coTravellerDataAPI,
  validatFormAPI,
  getAirlineInfoAPI,
  submitV2API,
  getTxnIdDetailsAPI,
  zcPriceAPI,
  getImpInfoAPI
} from '@ibibo/hulk-apis';
import { PethoesAPI } from '@ibibo/pethoes-apis';
import {
  setRepriceData,
  setToken,
  setRulesData,
  setGetPriceData,
  setMinifiedData,
  setPromoLoading,
  setRepriceLoading,
  setGetPriceLoading,
  setSubmitLoading,
  setSubmitResponse,
  setSavedTravellersDetails,
  setRedirectToSrpError,
  setSeatsAmount,
  setPriceLockSoldout,
  setBRPData,
  setImportantInfo,
  setBRPLoading,
  setSRPOfferShow
} from './actions';
import {
  searchParamObjectToUrl,
  enableCss,
  disableCss,
  seatsRepriceRequest,
  searchStringToObject,
  getTravellerParams,
  getContactDetailsParams,
  checkDocumentTypeIfExists
} from '../utils/reviewPageUtils';
import {
  tokenSelector,
  txnIdSelector,
  flavourSelector,
  submitRequestSelector,
  repriceRequestSelector,
  urlSearchParamSelector,
  repriceParamsSelector,
  rulesRequestSelector,
  isDomesticSelector,
  flightSearchDataSelector,
  contactDetailsSelector,
  directlyLandedSelector,
  lockPriceSelector,
  travellerFormDataSelector,
  bookingReviewDataSelector,
  repriceRequestGroundupSelector,
  searchDetailsSelector
} from './selectors';
import { isStoreEmptySelector, staticInformationSelector } from '../../SRP/redux/selectors';
import { experimentMetaDataSelector } from '../../Home/redux/selectors';
import {
  setGetPriceTimerID,
  setContactDetails,
  setBookData,
  setSelectedMeals,
  setSelectedBaggage,
  setMealsAmount,
  setBaggageAmount,
  setAddonsRetried
} from './actions';
import { addStaticInformation } from '../../SRP/redux/actions';
import { setSrpFromRepriceAddons, setSrpMebLiteFromRepriceAddons } from '../../utils/common/utils';
import sendDataToNewrelic from '@stencil/send-data-to-new-relic';
import { gaPageViewThunk } from '@stencil/flights-ga-thunks';
import { flightsReducersPdtLoggingThunk } from '../../utils/common/common-thunks';
import { getTotal } from '@stencil/seats/src/utils/seats-utils';

import {
  sendPokusDataToNewrelic,
  flightsAnalyticsLoggingThunk
} from '../../utils/common/common-thunks';
import { storeStatusSelector } from '../../SRP/redux-lite/selectors';

export const PRICING_FAILURE_MSG = 'Fare or Seat(s) not available with the airline.'; // TODO: put it in constants
const isBRPLite = IS_MWEB_LITE || false;
const pushPdtApiFailureError = (dispatch, err) => {
  dispatch(
    flightsReducersPdtLoggingThunk({ action_name: 'api_failure_error', error_message: err })
  );
};

export function fetchData(openPayments) {
  return function (dispatch, getState) {
    const repriceParams = repriceParamsSelector(getState());
    const token = tokenSelector(getState());
    const txnId = txnIdSelector(getState());
    const searchDetails = isBRPLite && searchDetailsSelector(getState());
    const repriceRequest = isBRPLite
      ? repriceRequestGroundupSelector(getState())
      : repriceRequestSelector(getState());

    const lockPrice = lockPriceSelector(getState());
    const flavour = flavourSelector(getState());
    const experimentMetaData = experimentMetaDataSelector(getState());
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;

    const localBookData = localStorage.getItem('bookingReviewData');

    if (token) {
      // For reload and direct landing
      dispatch(getRepriceAddonOnLoad(repriceParams, Boolean(isBRPLite)));
    } else if (txnId) {
      dispatch(getTxnDetailsOnLoad(repriceParams, Boolean(isBRPLite)));
      // } else if (repriceRequest && repriceRequest.minified_data) {
    } else if (repriceRequest && repriceRequest.query_data) {
      if (lockPrice) {
        dispatch(fareLockRequest(repriceRequest, openPayments));
      } else {
        dispatch(postRepriceAddon(repriceRequest));
      }
    } else if (localBookData) {
      try {
        const bookingReviewData = JSON.parse(localBookData);
        // const { gocashoffer, utm_source, utm_medium, campaign } = bookingReviewData;
        const {
          gocashoffer,
          gi_source = '',
          gi_medium = '',
          campaign,
          utm_medium = '',
          utm_source = ''
        } = bookingReviewData;

        let requestObj;
        if (
          experimentMetaData &&
          experimentMetaData['GI_FLT_RCOM_RID_REPRICE_ADDONS']?.gi_flt_rcom_rid_reprice_addons
        ) {
          const { si = {}, o = [], r = [] } = bookingReviewData.bookData || {};
          const { ri = {} } = si;
          const { rid = '' } = ri;
          const rcoms = {};
          if (o && o.length) {
            const onwFlt = o[0];
            rcoms[onwFlt.cid] = onwFlt.fk;
          }
          if (r && r.length) {
            const retFlt = r[0];
            rcoms[retFlt.cid] = retFlt.fk;
          }
          requestObj = {
            ...(gi_source ? { gi_source } : null),
            ...(gi_medium ? { gi_medium } : null),
            ...(utm_source ? { utm_source } : null),
            ...(utm_medium ? { utm_medium } : null),
            query_data:
              bookingReviewData &&
              bookingReviewData.queryParam &&
              bookingReviewData.queryParam.split('-').slice(0, 9).join('-'),
            flavour,
            v: fareBreakupVersion ? 1.6 : 1.5,
            rid,
            rcoms: JSON.stringify(rcoms)
          };
        } else {
          requestObj = {
            query_data:
              bookingReviewData &&
              bookingReviewData.queryParam &&
              bookingReviewData.queryParam.split('-').slice(0, 9).join('-'),
            minified_data:
              bookingReviewData &&
              bookingReviewData.bookData &&
              JSON.stringify(bookingReviewData.bookData),
            gocashoffer,
            ...(gi_source ? { gi_source } : null),
            ...(gi_medium ? { gi_medium } : null),
            ...(utm_source ? { utm_source } : null),
            ...(utm_medium ? { utm_medium } : null),
            campaign
          };
        }
        dispatch(setBookData(bookingReviewData));
        if (lockPrice) {
          dispatch(fareLockRequest(requestObj, openPayments));
        } else {
          dispatch(postRepriceAddon(requestObj));
        }
        localStorage.removeItem('bookingReviewData');
      } catch (e) {
        sendDataToNewrelic('Redirect Error: FetchData', e.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      }
    } else if (searchDetails && isBRPLite) {
      dispatch(getBRPInfo(searchDetails));
      if (repriceRequest) {
        dispatch(postRepriceAddon(repriceRequest, true));
        if (repriceRequest?.applied_addons) {
          dispatch(setSRPOfferShow(true));
        }
      }
    } else {
      sendDataToNewrelic('Redirect Error: FetchData', 'BookData Not found');
      dispatch(setRedirectToSrpError(NO_BOOK_DATA_ERROR, ERROR_HEADING));
    }
  };
}

function setRepriceAddonsData(response, isBRPLite = false) {
  return function (dispatch, getState) {
    const { brp } = getState();
    const urlParams = urlSearchParamSelector(getState());
    const directlyLanded = directlyLandedSelector(getState()); // for url params of srp
    const contactDetails = contactDetailsSelector(getState());
    const bookingReviewData = bookingReviewDataSelector(getState());
    const flavour = flavourSelector(getState());

    const { repriceData, getPriceTimerId } = brp;
    dispatch(setRepriceLoading(false));
    if (window.location.href.includes('flight-review')) {
      if (response.error) {
        sendDataToNewrelic(
          'Redirect Error: setRepriceAddonsData',
          'RepriceAddons response error: ' + response.error
        );
        dispatch(
          setRedirectToSrpError(
            response.error_message || REDIRECTING_TO_SRP_ERROR,
            REDIRECTING_TO_SRP_ERROR_HEADING
          )
        );
        // TODO: Error popup & redirect to srp
      } else {
        if (response.minified_data) {
          if (response.minified_data.si) {
            dispatch(addStaticInformation(response.minified_data.si));
          }
          dispatch(setMinifiedData(response.minified_data));
        }
        if (response.query_data) {
          dispatch(
            setBookData({
              ...bookingReviewData,
              queryParam:
                response.query_data +
                (response.int || response?.ipd?.is_international ? '-I' : '-D')
            })
          );
        }
        if (repriceData.t !== response.t) {
          const t = response.t;
          dispatch(setToken(t));
          dispatch(getImportantInfo({ t, flavour }));
          // hit getPrice in interval
          if (getPriceTimerId) {
            clearInterval(getPriceTimerId);
          } else {
            dispatch(sendPokusDataToNewrelic('review'));
            dispatch(flightsReducersPdtLoggingThunk({ action_name: 'load_page' }));
            setTimeout(() => {
              dispatch(gaPageViewThunk('FlightsBookingReviewPage', flightSearchDataSelector));
            }, 1000);

            dispatch(getPriceData({ token: t }, response.raa)); // Calling getPrice the first time
          }
          let timerId = setInterval(() => {
            return dispatch(getPriceData({ token: t }));
          }, response.rf || 300000);
          dispatch(setGetPriceTimerID(timerId));

          // set url
          let urlParamsCopy = { ...urlParams };
          if (!urlParamsCopy) {
            urlParamsCopy = {};
          }
          if (!urlParams && directlyLanded?.isDirectlyLanded) {
            urlParamsCopy = searchStringToObject(directlyLanded.searchString);
          } else if (location.search) {
            urlParamsCopy = searchStringToObject(location.search);
          }
          urlParamsCopy.t = t;
          const url = searchParamObjectToUrl(urlParamsCopy);
          window.history.replaceState({}, 'bookingToken', url);
        }
        if (response.query_data && !isBRPLite) {
          const { query_data } = response;
          const paramUrl = query_data.split('air-')[1];
          const isIntl = response.int || response?.ipd?.is_international ? true : false;
          const params = `${paramUrl}-${isIntl ? 'I' : 'D'}`;
          const isStoreEmpty = isStoreEmptySelector(getState());
          if (isStoreEmpty) {
            setSrpFromRepriceAddons(params, dispatch);
          }
        } else if (response.query_data && isBRPLite) {
          const param = response.query_data.split('air-')[1];
          const searchString = `${param}-R/`;
          const isStoreEmpty = storeStatusSelector(getState());
          if (isStoreEmpty) {
            setSrpMebLiteFromRepriceAddons(searchString, dispatch);
          }
        }
        if (response.selected_meals_baggage?.meal) {
          dispatch(setSelectedMeals(response.selected_meals_baggage.meal));
          const mealAmt = response.ab.find(addon => addon.k.includes('Meal'))?.v || null;
          dispatch(setMealsAmount(mealAmt));
        } else {
          dispatch(setSelectedMeals({}));
          dispatch(setMealsAmount(null));
        }
        if (response.selected_meals_baggage?.baggage) {
          dispatch(setSelectedBaggage(response.selected_meals_baggage.baggage));
          const baggageAmt = response.ab.find(addon => addon.k.includes('Baggage'))?.v || null;
          dispatch(setBaggageAmount(baggageAmt));
        } else {
          dispatch(setSelectedBaggage({}));
          dispatch(setBaggageAmount(null));
        }
        if (response?.seat_info) {
          const selectedSeats = seatsRepriceRequest(response.seat_info);
          const seatAmt = selectedSeats.seat_data.length > 0 ? getTotal(response?.seat_info) : null;
          dispatch(setSeatsAmount(seatAmt));
        } else {
          dispatch(setSeatsAmount(null));
        }
        dispatch(setRepriceData(response));
        dispatch(getBaggageDataAndFareRules());
        if (
          !contactDetails.mobile &&
          !contactDetails.email &&
          response.emp &&
          (response.emp.e || response.emp.m)
        )
          dispatch(setContactDetails({ mobile: response.emp.m, email: response.emp.e }));
      }
    }
  };
}

export function getRepriceAddonOnLoad(urlSearchParam, isBRPLite = false) {
  const param = urlSearchParam;
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const experimentMetaData = experimentMetaDataSelector(getState());
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;

    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };

    dispatch(setRepriceLoading(true));
    getRepriceAddonsAPI(
      { flavour, ...param, v: fareBreakupVersion ? 1.6 : 1.5 },
      pdtApiFailureError
    )
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
      })
      .catch(err => {
        sendDataToNewrelic('Redirect Error: getRepriceAddonOnLoad', err.message);
        if (isBRPLite) {
          logRepriceErrorForMwebLite(err.message);
        } else {
          pushPdtApiFailureError(dispatch, err.message);
        }
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function getImportantInfo(urlSearchParam) {
  const param = urlSearchParam;
  return function (dispatch, getState) {
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    getImpInfoAPI(param, pdtApiFailureError)
      .then(response => {
        dispatch(setImportantInfo(response));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getImportantInfo', err.message);
      });
  };
}

export function getBRPInfo(urlSearchParam = {}) {
  return function (dispatch, getState) {
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setRepriceLoading(true));
    dispatch(setBRPLoading(true));
    getBRPDetails(urlSearchParam, pdtApiFailureError)
      .then(response => {
        dispatch(setBRPData(response));
        dispatch(setBRPLoading(false));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getBRPInfo', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function getTxnDetailsOnLoad(urlSearchParam, isBRPLite = false) {
  const param = urlSearchParam;
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const experimentMetaData = experimentMetaDataSelector(getState());
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;

    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setRepriceLoading(true));
    if (param.fare_lock_txn_id) {
      delete Object.assign(param, { ['frl_txn_id']: param['fare_lock_txn_id'] })[
        'fare_lock_txn_id'
      ];
    }
    getTxnIdDetailsAPI({ flavour, ...param, v: fareBreakupVersion ? 1.6 : 1.5 }, pdtApiFailureError)
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getRepriceAddonOnLoad', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function retryRepriceAddon(urlSearchParam, isBRPLite) {
  const param = { addons_hit: true, ...urlSearchParam };
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const experimentMetaData = experimentMetaDataSelector(getState());
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;

    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };

    dispatch(setRepriceLoading(true));
    getRepriceAddonsAPI(
      { flavour, ...param, v: fareBreakupVersion ? 1.6 : 1.5 },
      pdtApiFailureError
    )
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
        dispatch(setAddonsRetried(true));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: retryRepriceAddon', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
        dispatch(setAddonsRetried(true));
      });
  };
}

export function postRepriceAddon(param, isBRPLite = false) {
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const experimentMetaData = experimentMetaDataSelector(getState());

    const pdtApiFailureError = err => {
      if (isBRPLite) {
        logRepriceErrorForMwebLite(err?.message);
        return;
      }
      pushPdtApiFailureError(dispatch, err);
    };

    const logRepriceErrorForMwebLite = msg => {
      const action_name = 'reprice_failure_error';
      const category = 'flightsGroundUp_BRP';
      dispatch(
        flightsAnalyticsLoggingThunk({
          pdtInfo: {
            action_name,
            meta_data: { category, msg }
          },
          gaInfo: {
            eventCategory: category,
            eventAction: action_name,
            eventLabel: msg
          }
        })
      );
    };

    dispatch(setRepriceLoading(true));
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;
    postRepriceAddonsAPI(
      { flavour, ...param, v: fareBreakupVersion ? 1.6 : 1.5 },
      pdtApiFailureError
    )
      .then(response => {
        dispatch(setRepriceAddonsData(response, isBRPLite));
      })
      .catch(err => {
        if (isBRPLite) {
          logRepriceErrorForMwebLite(err?.message);
        } else {
          pushPdtApiFailureError(dispatch, err.message);
        }
        sendDataToNewrelic('Redirect Error: PostRepriceAddon', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function fareLockRequest(param, openPayments) {
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setSubmitLoading(true));
    fareLockRequestAPI({ flavour, ...param }, pdtApiFailureError)
      .then(response => {
        dispatch(setSubmitLoading(false));
        dispatch(setSubmitResponse(response));
        if (!response.success) {
          sendDataToNewrelic('Redirect Error: farelockRequest', response.msg || 'Response Error');
          dispatch(
            setRedirectToSrpError(
              response.msg || REDIRECTING_TO_SRP_ERROR,
              REDIRECTING_TO_SRP_ERROR_HEADING
            )
          );
        } else {
          openPayments();
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: PostFareLock', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function applyRemoveAddons(appliedAddons, removeAddons, callback = null) {
  return function (dispatch, getState) {
    const token = tokenSelector(getState());
    const flavour = flavourSelector(getState());
    const experimentMetaData = experimentMetaDataSelector(getState());
    const data = { token, flavour };

    if (appliedAddons) {
      data.applied_addons = JSON.stringify(appliedAddons);
      if (appliedAddons.promo) {
        dispatch(setPromoLoading(appliedAddons.promo));
      }
    }
    if (removeAddons) {
      data.removed_addons = JSON.stringify(removeAddons);
      if (removeAddons.promo) {
        dispatch(setPromoLoading(removeAddons.promo));
      }
    }
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    dispatch(setRepriceLoading(true));
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;
    postRepriceAddonsAPI({ ...data, v: fareBreakupVersion ? 1.6 : 1.5 }, pdtApiFailureError)
      .then(response => {
        dispatch(setRepriceLoading(false));
        dispatch(setPromoLoading(''));
        if (response.error) {
          if (callback) {
            callback(response.error);
          }
          sendDataToNewrelic('Redirect Error: applyRemoveAddons', response.error);
          dispatch(
            setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING)
          );
        } else {
          dispatch(setRepriceData(response));
          if (callback) {
            callback(null, response);
          }
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: applyRemoveAddons', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
        if (callback) {
          callback(err);
        }
        // TODO: Error popup & redirect to srp
      });
  };
}

export function getBaggageDataAndFareRules() {
  return function (dispatch, getState) {
    const param = rulesRequestSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    baggageDataAndFareRulesAPI(param, pdtApiFailureError)
      .then(response => {
        dispatch(setRulesData(response?.baggage_data || null, response.minirules_data || null));
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export function getPriceData(param, retryAddons = false) {
  return function (dispatch, getState) {
    const experimentMetaData = experimentMetaDataSelector(getState());
    const fareBreakupVersion =
      experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;
    param.v = fareBreakupVersion ? 1.6 : 1.5;

    dispatch(setGetPriceLoading(true));
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    getPriceAPI(param, pdtApiFailureError)
      .then(response => {
        dispatch(setGetPriceData(response));
        dispatch(setGetPriceLoading(false));
        if (response.error) {
          sendDataToNewrelic('Redirect Error: getPriceData', response.error);
          if (response.Refund && response.Refund === 'success' && response.is_fare_lock_txn_id) {
            dispatch(setPriceLockSoldout({ priceLockSoldout: true }));
          } else {
            dispatch(
              setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING)
            );
          }
          return;
        }
        if (response.farediff) {
          const dataObj = {
            token: param.token,
            extra_params: JSON.stringify({ farediff: response.farediff })
          };
          dispatch(postRepriceAddon(dataObj));
        }
        if (retryAddons) {
          dispatch(retryRepriceAddon({ t: param.token }));
        } else {
          dispatch(setAddonsRetried(true));
        }
        if (!response.farediff && !retryAddons) {
          const dataObj = {
            token: param.token
          };
          dispatch(postRepriceAddon(dataObj));
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: getPriceData', err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function submitV2(openPayments, openFareChange) {
  // callback before opening Payments page
  return function (dispatch, getState) {
    const param = submitRequestSelector(getState());
    const updatedParam = isBRPLite ? { ...param, isgup: isBRPLite } : param;
    const flavour = flavourSelector(getState());
    dispatch(setSubmitLoading(true));
    enableCss(['mStyles', 'html5Payment']); // enable Payments CSS
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    submitV2API(updatedParam, pdtApiFailureError)
      .then(response => {
        dispatch(setSubmitLoading(false));
        dispatch(setSubmitResponse(response));
        if (response && response.ipc && response.ssd) {
          openFareChange();
          disableCss(['mStyles', 'html5Payment']);
        } else if (response.success) {
          if (response.payment_url) {
            dispatch(
              gaPageViewThunk(
                'FlightsBookingReviewPage',
                flightSearchDataSelector,
                '/flight-review/paymentPage/'
              )
            );
            window.open(response.payment_url, '_self');
          } else {
            setTimeout(() => {
              dispatch(
                gaPageViewThunk(
                  'FlightsBookingReviewPage',
                  flightSearchDataSelector,
                  flavour === 'v2' ? '/flights/newpaymentblock/' : ''
                )
              );
            }, 1000);
            openPayments();
          }
        } else {
          disableCss(['mStyles', 'html5Payment']);
          sendDataToNewrelic('Redirect Error: submitV2', response.msg || 'Response Error');
          dispatch(
            setRedirectToSrpError(
              response.msg || REDIRECTING_TO_SRP_ERROR,
              REDIRECTING_TO_SRP_ERROR_HEADING
            )
          );
        }
      })
      .catch(err => {
        disableCss(['mStyles', 'html5Payment']);
        dispatch(setSubmitLoading(false));
        pushPdtApiFailureError(dispatch, err.message);
        sendDataToNewrelic('Redirect Error: submitV2', 'Error: ' + err.message);
        dispatch(setRedirectToSrpError(REDIRECTING_TO_SRP_ERROR, REDIRECTING_TO_SRP_ERROR_HEADING));
      });
  };
}

export function getSavedTravellersData() {
  return function (dispatch, getState) {
    const param = { action_type: 'getall', lob: 'DF' };
    const isDomestic = isDomesticSelector(getState());
    const travellerFormData = travellerFormDataSelector(getState());
    const travellerDocumentList = travellerFormData?.TRAVELER_DOCUMENT_LIST?.list || [];

    if (!isDomestic) {
      param.lob = 'IF';
    }
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    coTravellerDataAPI(param, pdtApiFailureError)
      .then(response => {
        if (response.data && Array.isArray(response.data)) {
          dispatch(
            setSavedTravellersDetails(
              checkDocumentTypeIfExists(response.data, travellerDocumentList)
            )
          );
        }
      })
      .catch(err => {
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export function validationTravellerDetailsAPI(callback, param) {
  validatFormAPI(param)
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(null, err);
    });
}

export function validateEachTraveller(callback, paxDetail, paxType, token, flavour) {
  const param = getTravellerParams(paxDetail, paxType, token, flavour);
  validationTravellerDetailsAPI(callback, param);
}

export function validateContactDetailsFormApi(callback, contactDetails, token, flavour) {
  const param = getContactDetailsParams(contactDetails, token, flavour);
  validationTravellerDetailsAPI(callback, param);
}

export function validateGstDetailsFormApi(callback, gstDetails, token, flavour) {
  validationTravellerDetailsAPI(callback, { gstdata: JSON.stringify(gstDetails), token, flavour });
}

export function getAirlineInfo(
  callback,
  travellerInfo: { firstname?: string; title?: string; buttonType?: string }
) {
  getAirlineInfoAPI()
    .then(response => {
      callback(response, travellerInfo);
    })
    .catch(err => {
      callback(null, travellerInfo);
    });
}

export function validateTravellersApi(callback) {
  return function (dispatch, getState) {
    const param = submitRequestSelector(getState());
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };
    validatFormAPI(param, pdtApiFailureError)
      .then(response => {
        callback(response);
      })
      .catch(err => {
        callback(null, err);
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export function fetchZCPriceDetailThunk(callback) {
  return function (dispatch, getState) {
    const param = {
      token: tokenSelector(getState())
    };
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    zcPriceAPI(param, pdtApiFailureError)
      .then(response => {
        callback(response);
      })
      .catch(err => {
        callback(null, err);
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

// Pethos APIs

const getFirstKeyObject = (obj, k, index) =>
  obj && obj[k] && Object.keys(obj[k]).length && obj[k][Object.keys(obj[k])[index]];

export function getReviewPersuasion(callback, position, isSRP = false) {
  return function (dispatch, getState) {
    const flavour = flavourSelector(getState());
    const param = {
      requestId: !isSRP
        ? tokenSelector(getState())
        : staticInformationSelector(getState())?.ri?.rid,
      funnelStep: !isSRP ? 'REVIEW' : 'LISTING',
      flavour: flavour ? flavour : 'v2'
    };
    const pdtApiFailureError = err => {
      pushPdtApiFailureError(dispatch, err);
    };

    PethoesAPI(param, pdtApiFailureError)
      .then(response => {
        const index = response.positionlist?.indexOf(position);

        if (index >= 0) {
          const pLevelObj = getFirstKeyObject(response?.data?.c, 'p', index);
          const cpuLevelList = pLevelObj.cpu;
          const ioLevelList = pLevelObj.io;
          const persuasionArray = cpuLevelList || ioLevelList;
          const persuasionObject = persuasionArray.sort((a, b) => a.priority - b.priority)[0];

          if (
            persuasionObject &&
            persuasionObject.data &&
            typeof persuasionObject.data.value === 'string'
          ) {
            const data = JSON.parse(persuasionObject.data.value);
            callback(data);
          }
        }
      })
      .catch(err => {
        callback(null, err);
        pushPdtApiFailureError(dispatch, JSON.stringify(err));
      });
  };
}

export const getRepriceReqDetails = (
  query,
  experimentMetaData,
  onwardSelectedFlight,
  returnSelectedFlight
) => {
  const rid = query?.search_id;
  const fareBreakupVersion =
    experimentMetaData && experimentMetaData['GI_FLT_FARE_BREAKUP']?.GI_FLT_FARE_BREAKUP;

  const flight = {};
  let onwardFlightKey = '',
    onwardFlightVal = '',
    returnFlightKey = '',
    returnFlightVal = '';
  if (onwardSelectedFlight && onwardSelectedFlight.id) {
    onwardFlightKey = Object.keys(onwardSelectedFlight?.id)[0];
    onwardFlightVal = Object.values(onwardSelectedFlight?.id)[0][0];
  }
  if (onwardFlightKey && onwardFlightKey) flight[onwardFlightKey] = onwardFlightVal;

  if (returnSelectedFlight && returnSelectedFlight.id) {
    returnFlightKey = Object.keys(returnSelectedFlight?.id)[0];
    returnFlightVal = Object.values(returnSelectedFlight?.id)[0][0];
  }
  if (returnFlightKey && returnFlightVal) flight[returnFlightKey] = returnFlightVal;

  return {
    v: fareBreakupVersion ? 1.6 : 1.5,
    rid,
    rcoms: flight
  };
};
